import { errorDefinitions } from "./definitions";
import _ from "lodash";
import NiceModal from "@ebay/nice-modal-react";

export function showErrorPopup(data, code) {
  if (data && code) data.code = code;
  if (!data) {
    data = translateError();
  }
  NiceModal.show("error-modal", { ...data });
}

export const translateError = (error, id = false) => {
  let errorDetails = {};

  if (error) {
    errorDetails = errorDefinitions.filter(e => e.ident === error)[0] || errorDefinitions.filter(e => e.ident === "generic")[0]

    if (id && Object.keys(errorDetails?.custom?.find(e => e.id === id) ?? {}).length !== 0) {
      return errorDetails.custom.find(e => e.id === id)
    }

    return errorDetails;
  }
  
  errorDetails = _.filter(errorDefinitions, {
    ident: "generic",
  })[0];
  return errorDetails;
};
